import { Answer, Question, questions } from "@/data/questions";
import { getScores } from "@/store/scores";
import { stats } from "@/store/stats";
import { profanityList } from "./profaneWordList";

export function diff(num1: number, num2: number) {
  if (num1 > num2) {
    return num1 - num2;
  } else {
    return num2 - num1;
  }
}

export function getPercentage(score: number, min: number, max: number) {
  if (score >= max) {
    return 100;
  }
  if (score <= min) {
    return 0;
  }

  const range = diff(min, max);
  const part = 100 / range;
  let percent = 0;
  const offset = Math.abs(min);
  if (min < 0) {
    percent = (score + offset) * part;
  } else {
    percent = (score - offset) * part;
  }
  return percent;
}

export function returnQuestionStat(key: string, questionId: number): number {
  if (stats.value === null || stats.value === undefined) {
    return 0;
  }

  const q = stats.value[questionId];

  if (q === undefined) {
    return 0;
  }

  let stat = -1;
  q.forEach((element: any) => {
    if (element[0] === key) {
      stat = element[1];
    }
  });

  return stat > 0 ? stat : 0;
}

export function getPopularAnswer(questionId: number): Answer | null {
  if (stats.value === null || stats.value === undefined) {
    return null;
  }
  //get question stats
  const q = stats.value[questionId];
  if (q === undefined) {
    return null;
  }

  let max = -1;
  let pop = "";

  //loop through question stats, assigning new max when one is found
  q.forEach((element: any) => {
    if (element[0] !== "total" && element[1] > max) {
      max = element[1];
      pop = element[0];
    }
  });

  let ans = null;
  //loop through related questions looking for answer with key = pop
  questions[questionId].answers.forEach((element) => {
    if (element.key === pop) {
      ans = element;
    }
  });

  return ans;
}

export function getPopularAnswers() {
  const popularAnswers: Answer[] = [];
  for (let i = 0; i < questions.length; i++) {
    const a = getPopularAnswer(i);
    if (a) {
      popularAnswers.push(a);
    }
  }
  return popularAnswers;
}

export function isProfane(text: string) {
  //checks each word of sentence
  const strArr = text.split(/[!,?,.\s()%$£+=\-^"~#'@<>&]/);

  return strArr.some((w) => profanityList.includes(w));

  //checks all text for profane words (words such as fulcrum count as profanity bc they contain fu)
  // return profanities.some((profane) => text.includes(profane));
}

export function ISOtoDateGB(date: any) {
  console.log(date);
  if (date === "" || date === null || date === undefined) {
    return "n/a";
  }
  return new Date(date).toLocaleDateString("en-GB");
}
